'use strict';

function LoanLiquidAdditionalPaymentReview() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    if (!this._checkAdditionalPaymentFlowEligibility()) {
      return;
    }

    this._form = $(this.node).find('form');
    this._form.on('submit', this._onConfirmSubmit.bind(this));

    $('.loans-payment-additional-review__date a').on('click', function () {
      _this.presenter.removeModelProperty('money.loans.loans[0].create_additional.amount');
    });

    this.presenter.extendViewMap({
      'money.loans.loans[0].create_additional.date': {
        get: function get(val) {
          // Need to return a full date with year.
          return val ? moment(val).format('ddd, MMM D') : '';
        }
      }
    });

    this.presenter.addComputedVariable('next_regular_payment_amount', ['money.loans.loans[0].next_payments', 'money.loans.loans[0].additional_payment_maximum_date'], function (nextPayments, nextAvailablePaymentDate) {
      var amount = 0;
      nextAvailablePaymentDate = moment(nextAvailablePaymentDate);
      for (var i = 0; i < nextPayments.length; i++) {
        var regularPaymentDate = moment(nextPayments[i].date);
        if (nextAvailablePaymentDate.isSame(regularPaymentDate)) {
          amount = nextPayments[i].amount + nextPayments[i].protection_amount;
          break;
        }
      }
      return amount.toFixed(2);
    });

    this.presenter.addComputedVariable('total_payment_amount', ['money.loans.loans[0].create_additional.selection', 'money.loans.loans[0].create_additional.amount'], function (type, additionalAmount) {
      var totalAmount = +additionalAmount;
      if (type === 'next_available') {
        totalAmount += +_this.presenter._getComputedValue('next_regular_payment_amount');
      }

      return totalAmount.toFixed(2);
    });

    this._pushAnalytics();

    $('.loans__tray-loader').addClass('hide');
    $('.loans__content-wrapper').removeClass('hide');
  };

  this._pushAnalytics = function () {
    if (this.presenter.models.money.loans.loans[0].create_additional) {
      if (this.presenter.models.money.loans.loans[0].create_additional.selection === 'custom') {
        this.analytics.pushEvent('virtual-page-view', { Page: [window.location.href + '/custom'] });
      } else {
        this.analytics.pushEvent('virtual-page-view', {
          Page: [window.location.href + '/next_available']
        });
      }
    }
  };

  this._onConfirmSubmit = function (e) {
    e.preventDefault();

    $('.loans__tray-loader').removeClass('hide');
    $('.loans__content-wrapper').addClass('hide');

    // Retrieve parameters
    var createAdditional = this.presenter.models.money.loans.loans[0].create_additional;
    var params = {
      payment_type: 'paydown',
      amount: +createAdditional.amount,
      date: moment(createAdditional.date).format('YYYY-MM-DD')
    };
    this.createAdditionalPayment(params, this._onSubmitResponse.bind(this), this._onSubmitResponse.bind(this));
  };

  this._onSubmitResponse = function (data, response) {
    if (response === 200) {
      var formAnalyticsID = this._form.data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this._history.goToUrl(this.paths.loans.liquid.add_payment.additional.confirm_success);
    } else {
      this._history.goToUrl(this.paths.loans.liquid.add_payment.additional.confirm_failed);
    }
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('next_regular_payment_amount');
    this.presenter.removeComputedVariable('total_payment_amount');

    this._super();
  };
}